var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitorTheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_60_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_60_2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_60_2",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_60_2",
    width: 64,
    height: 64,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAhRJREFUeJztmk1rE1EUhp8zcysUFBS7UaRqqgmuXBU3reg/8H8kxZUgiBtxpSvRgv9GBDfVlRshKX5QsC4sWOhCkJkcFx1LipsJneYtzHlWuZM7733mJUNuwkAQtBoD6N/4dNnL/LHBMnBa7HTc7Bm8z4v09MWXpS1bu7a5NM78A/g5tdmM2fUyX07jbPwcaNvFA5y1vHyWgNsTB38DP0RCs+ICMF+9Xk3A+YO33DbWN7t3FVazon999AbzO9VwIVPKnASiALWAmihALaAmClALqIkC1AJqogC1gJooQC2gJgpQC6iJAtQCaqIAtYCaKEAtoCYKUAuoiQLUAmqiALWAmihALaAmClALqIkC1AJqogC1gJrWF2D97vAnsFCNG3tKzOCU7+fmR4wqDXYc/jThxeGnxHaSwzuDe9WBeaDTxCreRMg+cw6XmoubwPxtRpk/AHaPZYETjf3yIj00gPudz4tFKh4Bt4AzjcTDokMCcMwNL6Y537FkuFVZhcNWE17AHrBRwpPXo953ayj0P/rd4VfgSjX8tj7qXZ3l+XVp/bdAFKAWUBMFqAXURAFqATWtL6D2RmitO7w5hlfAxXrBvuhYqkbOlDtBsMTBTtALx+ruBLczGLwc9T7WmZzq6lQXv1J3vh/q1g2Yq3vuv4SJrET9H2mdynW1zuTW3wK1PwEZDKa7BWT/B2xnMDjimkHQFv4CQXd2fwXEVFYAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorTheme);
export default __webpack_public_path__ + "static/media/monitor_theme.6875991e750837b43e38b71d62a0446c.svg";
export { ForwardRef as ReactComponent };